// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Styles
import './styles.scss';

import DummyImg from 'assets/images/02.webp'


const HomePage = () => {
    const { userDetails, currentLang } = useSelector((store) => store.commonData)
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-md-12 text-center'>
                  <img src={DummyImg} alt="" className='mb-2' width="100%"/> 
                  <h3>Hope</h3>
                  <h6>190x120cm</h6>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
